import React, {useEffect, useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction,toJS} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../contexts";
import {input} from "../../utils/linker";
import ListSelector from "../Helpers/ListSelector";
import reactionCombiner from "../../utils/reactionCombiner";

function AnalyzerFieldSelector(props) {
  const store = useLocalObservable(() => ({
    focus: 0,
    ref: null,
    comb: null,
  }));
  const compStore = useContext(ComponentContext);

  useEffect(() => {
    // mount
    if(!store.comb) {
      store.comb=new reactionCombiner();
      store.comb.addReaction(()=>{
        return store.focus;
      },()=>{
        if(store.focus && store.ref) {
          setTimeout(()=> {
            store.ref.focus();
            console.log("FOCUS FIRE TRUE");
          },150);
        }
      })
    }

    return () => {
      // unmount
      store.comb.clear();
    }
  }, []);

  const inputRef = (ref)=> {
    runInAction(()=> {
      store.ref = ref;
      if (store.focus && store.ref) {
        store.ref.focus();
        store.focus = 0;
      }
    });

  };


  return (
    <div className="up12 splice">
      <div className="cell s-auto">
        <ListSelector
          visible_fields={["name_code"]}
          relative={true}
          placeholder={"Выберите поле"}
          fuzzerFields={["code","name"]}
          onBeforeChange={(e)=>{

          }}
          inputRef={(ref)=>{ inputRef(ref); }}
          idField={"code"}
          titleField={"name_code"}
          fields={compStore.category_fields.data}
          fetching={false}
          onNewFied={()=>{

          }}
          /*onSelectId={(id)=>{
            this.props.item[this.getValueField()]=id;
            // this.props.item.focus = 1;
          }}*/
          onLock={()=>{

          }}
          onCancel={()=>{
            // this.props.onCancel();
          }}
          onSelect={(item)=>{
            runInAction(()=> {
              if (item && item.code) {
                compStore.mapper[props.code].category_field_code=item.code;
                store.focus=1;
                // this.props.item.focus = 1;
              } else {
                compStore.mapper[props.code].category_field_code="";
                store.focus=1;
              }
            });
          }}
          selected_value={compStore.mapper[props.code].category_field_code}
        />
      </div>
      {compStore.mapper[props.code].category_field_code?(
        <div className="cell s-shrink s-middle">
          <span className="mdi mdi-close fs24 pointer const1" onClick={()=>{
            runInAction(()=>{
              compStore.mapper[props.code].category_field_code="";
            });
          }}></span>
        </div>
      ):null}
    </div>
  )
};

AnalyzerFieldSelector.defaultProps = {};

AnalyzerFieldSelector.propTypes = {}

export default observer(AnalyzerFieldSelector);
